<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
    [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div class="d-flex">
    <div>
        <app-superadminsidenav></app-superadminsidenav>
    </div>
    <div style="
        height: 100vh;
        overflow: scroll;
        width: 100%;
        background-color: rgba(250, 250, 250, 1);
      ">

        <div class="allergens-head">
            <div class="allergensBtn" [ngClass]="{ bgSelectClass: activeTab === 'information' }"
                (click)="setActiveTab('information')">
                Information
            </div>

            <div class="allergensBtn dietaryBtn" [ngClass]="{ bgSelectClass: activeTab === 'menuPlanning' }"
                (click)="setActiveTab('menuPlanning')">
                Menu Planning
            </div>

            <div class="allergensBtn dietaryBtn" [ngClass]="{ bgSelectClass: activeTab === 'calendar' }"
                (click)="setActiveTab('calendar')">
                Calendar
            </div>
        </div>



        <div *ngIf="activeTab === 'information'">
            <div class="page">
                <div class="page-header">
                    <div>
                        <h2>Regulatory Information </h2>
                        <p>Manage title and description for compliance items</p>
                    </div>

                    <button type="button" class="add-btn" (click)="addCard()">
                        + Add Card
                    </button>
                </div>

                <form [formGroup]="form">
                    <div formArrayName="cards" class="card-grid">
                        <ng-container *ngIf="cards.controls.length == 0">
                            <div class="no-cards">No cards added</div>
                        </ng-container>

                        <div class="compliance-card" *ngFor="let card of cards.controls; let i = index"
                            [formGroupName]="i">
                            <div class="card-top">
                                <h3>Information {{ i + 1 }}</h3>
                                <button type="button" class="remove-btn" (click)="removeCard(i)"
                                    *ngIf="cards.length > 1">
                                    Remove
                                </button>
                            </div>

                            <div class="form-group">
                                <label>Title</label>
                                <input type="text" formControlName="title" placeholder="Enter title" />
                                <small class="error" *ngIf="card.get('title')?.touched && card.get('title')?.invalid">
                                    Title is required
                                </small>
                            </div>

                            <div class="form-group">
                                <label>Description</label>
                                <textarea rows="4" formControlName="descriptions"
                                    placeholder="Enter description"></textarea>
                                <small class="error"
                                    *ngIf="card.get('descriptions')?.touched && card.get('descriptions')?.invalid">
                                    Description is required
                                </small>
                            </div>

                            <div class="card-actions">
                                <button type="button" class="save-btn" (click)="saveCard(i)">
                                    {{ savingIndex === i ? 'Saving...' : 'Save' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>




        </div>






        <div *ngIf="activeTab === 'menuPlanning'">
            <div class="page">
                <div class="page-header">
                    <div>
                        <h2>Menu Planning Resources</h2>
                        <p>Helpful information for strategic menu planning</p>
                    </div>

                    <button type="button" class="add-btn" (click)="addMenuPlanningCard()">
                        + Add Card
                    </button>
                </div>

                <form [formGroup]="menuPlanningForm">
                    <div formArrayName="resources" class="card-grid">
                        <div class="compliance-card menu-card"
                            *ngFor="let card of menuPlanningCards.controls; let i = index" [formGroupName]="i">
                            <div class="card-top">
                                <h3>Resource {{ i + 1 }}</h3>
                                <button type="button" class="remove-btn" (click)="removeMenuPlanningCard(i)"
                                    *ngIf="menuPlanningCards.length > 1">
                                    Remove
                                </button>
                            </div>

                            <div class="form-group">
                                <label>Title</label>
                                <input type="text" formControlName="title" placeholder="Enter title" />
                                <small class="error" *ngIf="card.get('title')?.touched && card.get('title')?.invalid">
                                    Title is required
                                </small>
                            </div>

                            <div class="form-group">
                                <label>Points</label>
                                <textarea rows="5" formControlName="pointsText"
                                    placeholder="Enter one point per line"></textarea>
                                <small class="helper-text">
                                    Example:
                                    Spring vegetables peak in April
                                    Local strawberries available May-June
                                </small>
                                <small class="error"
                                    *ngIf="card.get('pointsText')?.touched && card.get('pointsText')?.invalid">
                                    At least one point is required
                                </small>
                            </div>

                            <div class="preview-points" *ngIf="card.get('pointsText')?.value">
                                <p class="preview-label">Preview</p>
                                <ul>
                                    <li *ngFor="let point of card.get('pointsText')?.value.split('\n')">
                                        {{ point }}
                                    </li>
                                </ul>
                            </div>

                            <div class="card-actions">
                                <button type="button" class="save-btn" (click)="saveMenuPlanningCard(i)">
                                    {{ menuPlanningSavingIndex === i ? 'Saving...' : 'Save' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>






        <div *ngIf="activeTab === 'calendar'">
            <div class="calendar-page">
                <div class="calendar-header">
                    <div>
                        <h2>Event Planning Calendar</h2>
                        <p>Manage restaurant-facing events for current and next year</p>
                    </div>
                </div>

                <div class="year-switcher">
                    <button type="button" class="year-pill" *ngFor="let year of years.controls; let yi = index"
                        [ngClass]="{ active: selectedYearIndex === yi }" (click)="selectYear(yi)">
                        {{ getYearValue(yi) }}
                    </button>
                </div>

                <form [formGroup]="calendarForm">
                    <div formArrayName="years">
                        <div [formGroupName]="selectedYearIndex" class="calendar-layout">

                            <!-- LEFT: MONTHS -->
                            <div class="month-sidebar">
                                <div class="month-grid-modern" formArrayName="months">
                                    <div class="month-tile"
                                        *ngFor="let month of getMonths(selectedYearIndex).controls; let mi = index"
                                        [ngClass]="{ active: selectedMonthIndex === mi }" (click)="selectMonth(mi)">
                                        <div class="month-tile-top">
                                            <h4 class="month_name">{{ month.get('monthName')?.value }}</h4>
                                            <span class="event-badge">
                                                {{ getEventCount(selectedYearIndex, mi) }}
                                            </span>
                                        </div>

                                        <p>
                                            {{ getEventCount(selectedYearIndex, mi) === 1 ? 'event' : 'events' }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- RIGHT: SELECTED MONTH DETAILS -->
                            <div class="month-detail-card">
                                <div class="detail-header">
                                    <div>
                                        <h3>{{ getSelectedMonthName() }} {{ getYearValue(selectedYearIndex) }}</h3>
                                        <p>Add and manage events for this month</p>
                                    </div>

                                    <button type="button" class="primary-btn" (click)="addEventToSelectedMonth()">
                                        + Add Event
                                    </button>
                                </div>

                                <div class="events-list" formArrayName="months">
                                    <div [formGroupName]="selectedMonthIndex">
                                        <div formArrayName="events">

                                            <div class="empty-modern" *ngIf="getSelectedEvents().length === 0">
                                                <div class="empty-icon">📅</div>
                                                <h4>No events yet</h4>
                                                <p>Start by adding an event for {{ getSelectedMonthName() }}</p>
                                            </div>

                                            <div class="event-card-modern"
                                                *ngFor="let event of getSelectedEvents().controls; let ei = index"
                                                [formGroupName]="ei">
                                                <div class="event-card-top">
                                                    <div>
                                                        <h4>Event {{ ei + 1 }}</h4>
                                                        <span class="subtle-text">Restaurant side will display
                                                            this</span>
                                                    </div>

                                                    <button type="button" class="ghost-danger-btn"
                                                        (click)="removeEvent(ei)">
                                                        Remove
                                                    </button>
                                                </div>

                                                <div class="form-row">
                                                    <div class="form-group">
                                                        <label>Date</label>
                                                        <input type="date" formControlName="eventDate"
                                                            [attr.min]="getSelectedMonthMinDate()"
                                                            [attr.max]="getSelectedMonthMaxDate()" />
                                                        <small class="error"
                                                            *ngIf="event.get('eventDate')?.touched && event.get('eventDate')?.invalid">
                                                            Date is required
                                                        </small>
                                                    </div>
                                                </div>

                                                <div class="form-row">
                                                    <div class="form-group">
                                                        <label>Type</label>
                                                        <select formControlName="type">
                                                            <option value="">Select type</option>
                                                            <option *ngFor="let item of eventTypes" [value]="item">
                                                                {{ item | titlecase }}
                                                            </option>
                                                        </select>
                                                        <small class="error"
                                                            *ngIf="event.get('type')?.touched && event.get('type')?.invalid">
                                                            Type is required
                                                        </small>
                                                    </div>
                                                </div>

                                                <div class="form-row">
                                                    <div class="form-group">
                                                        <label>Title</label>
                                                        <input type="text" formControlName="title"
                                                            placeholder="Enter event title" />
                                                        <small class="error"
                                                            *ngIf="event.get('title')?.touched && event.get('title')?.invalid">
                                                            Title is required
                                                        </small>
                                                    </div>
                                                </div>

                                                <div class="form-row">
                                                    <div class="form-group">
                                                        <label>Description</label>
                                                        <textarea rows="3" formControlName="descriptions"
                                                            placeholder="Enter event description"></textarea>
                                                        <small class="error"
                                                            *ngIf="event.get('descriptions')?.touched && event.get('descriptions')?.invalid">
                                                            Description is required
                                                        </small>
                                                    </div>
                                                </div>

                                                <div class="event-card-actions">
                                                    <div type="button" class="save-event-btn" (click)="saveEvent(ei)">
                                                        {{ isSavingEvent(ei) ? 'Saving...' : 'Save Event' }}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="detail-footer">
                                    <button type="button" class="save-modern-btn" (click)="saveSelectedMonth()">
                                        {{ savingMonthKey === (selectedYearIndex + '-' + selectedMonthIndex) ?
                                        'Saving...' : 'Save Month' }}
                                    </button>
                                </div> -->
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>



    </div>
</div>